/* @flow */
import * as React from 'react'
import Login from '../login/Login'

const LoginLayout = props => {
  return <Login />
}

export default LoginLayout
